import apis from '../apis/api.actions';
import { parseQueryParams } from './parseParams';

// Dashboard API functions
export const getAdminDashboard = () => apis.getDatas(`v1/admin/dashboard`).then((res) => res);
export const getDepartmentalDashboard = () => apis.getDatas(`v1/admin/departmental-dashboard`).then((res) => res);

export const list_Incubatee = () => apis.getDatas(`v1/admin/incubatee`).then((res) => res);
export const list_internship_application = (params = {}) =>
    apis.getDatas(`v1/admin/internship-applications`, { params }).then((res) => res);
export const list_Incubation = () => apis.getDatas(`v1/incubator`).then((res) => res);
export const list_Edclub = () => apis.getDatas(`v1/admin/ed-register`).then((res) => res);
export const list_industry_academic = () => apis.getDatas(`v1/admin/industry-academia-applications`).then((res) => res);
export const list_facilitation = () => apis.getDatas(`v1/admin/facilitation`).then((res) => res);
export const change_status = (data) => apis.createData(`v1/admin/status`, data).then((res) => res);
export const change_application_status = ({ id, status }) =>
    apis.createData(`v1/admin/internship-applications/${id}/approve`, { status }).then((res) => res);
export const reject_application_status = ({ id, status }) =>
    apis.createData(`v1/admin/internship-applications/${id}/reject`, { status }).then((res) => res);
export const change_incubation_status = (id, data) => apis.createData(`v1/incubator/${data}/${id}`).then((res) => res);
export const change_edclub_status = (data) => apis.createData(`v1/admin/edc-status`, data).then((res) => res);
export const issue_certificate = (data) => apis.createData(`v1/admin/certificates/issue`, data).then((res) => res);
export const change_user_status = (data) => apis.createData(`v1/admin/user-status`, data).then((res) => res);
export const incubatee_details = (id) => apis.getDatas(`v1/admin/incubatee/${id}`).then((res) => res);
export const internship_application_details = (id) =>
    apis.getDatas(`v1/admin/internship-applications/${id}`).then((res) => res);
export const incubation_details = (id) => apis.getDatas(`v1/incubator/${id}`).then((res) => res);
export const academic_details = (id) =>
    apis.getDatas(`v1/admin/industry-academia-applications/${id}`).then((res) => res);
export const facilitation_details = (id) => apis.getDatas(`v1/admin/facilitation/${id}`).then((res) => res);
export const Edclub_details = (id) => apis.getDatas(`v1/admin/ed-register/${id}`).then((res) => res);
export const user_details = (id) => apis.getDatas(`v1/admin/user/${id}`).then((res) => res);
export const yearly_details = (id) => apis.getDatas(`v1/admin/edc-yearly-data/${id}`).then((res) => res);
export const program_details = (id) => apis.getDatas(`v1/admin/program/${id}`).then((res) => res);
export const complete_program_booking = (id) =>
    apis.createData(`v1/admin/bookings/${id}/complete`).then((res) => res);
export const program_bookings = (id) => apis.getDatas(`v1/bookings/${id}`).then((res) => res);
export const new_department = (data) => apis.createData(`v1/admin/department`, data).then((res) => res);
export const update_department = (id, data) => apis.createData(`v1/admin/department/${id}`, data).then((res) => res);
export const update_district = (id, data) => apis.updateData(`v1/admin/district/${id}`, data).then((res) => res);
export const list_department = () => apis.getDatas(`v1/admin/department`).then((res) => res);
export const delete_department = (id) => apis.deleteData(`v1/admin/department/${id}`).then((res) => res);
export const delete_event = (id) => apis.deleteData(`v1/admin/event/${id}`).then((res) => res);
export const delete_grievance = (id) => apis.deleteData(`v1/admin/grievances/${id}`).then((res) => res);
export const delete_incubation = (id) => apis.deleteData(`v1/admin/incubation-applications/${id}`).then((res) => res);
export const delete_facilitation = (id) => apis.deleteData(`v1/admin/facilitation/${id}`).then((res) => res);
export const shortlist_incubation = (id) =>
    apis
        .patchData(`v1/admin/incubation-applications/${id}/status`, {
            status: 'shortlisted',
        })
        .then((res) => res);

export const shedule_interview = (data) => apis.createData(`v1/admin/status`, data).then((res) => res);

export const delete_scheme = (id) => apis.deleteData(`v1/admin/scheme/${id}`).then((res) => res);
export const delete_program = (id) => apis.deleteData(`v1/admin/program/${id}`).then((res) => res);
export const list_events = () => apis.getDatas(`v1/admin/event`).then((res) => res);
export const list_incubation = () => apis.getDatas(`v1/admin/incubation-applications`).then((res) => res);
export const list_grievance = () => apis.getDatas(`v1/admin/grievances`).then((res) => res);
export const detail_events = (id) => apis.getDatas(`v1/admin/event/${id}`).then((res) => res);
export const detail_grievance = (id) => apis.getDatas(`v1/admin/grievances/${id}`).then((res) => res);
export const detail_incubation = (id) => apis.getDatas(`v1/admin/incubation-applications/${id}`).then((res) => res);
export const booking_events = (id) => apis.getDatas(`v1/eventbookings/${id}`).then((res) => res);
export const booking_events_status = (data) => apis.createData(`v1/admin/booking-status`, data).then((res) => res);
export const list_questions = () => apis.getDatas(`v1/questions`).then((res) => res);
export const get_program_questions = (id) => apis.getDatas(`v1/programs/${id}/questions`).then((res) => res);
export const send_questions = (id, data) => apis.createData(`v1/programs/${id}/questions`, data).then((res) => res);
export const forgot_password = (data) => apis.createData(`v1/admin/reset-url`, data).then((res) => res);
export const new_event = (data) =>
    apis.createData(`v1/admin/event`, data, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => res);
export const update_event = (id, data) =>
    apis
        .createData(`v1/admin/event/${id}`, data, { headers: { 'content-type': 'multipart/form-data' } })
        .then((res) => res);

export const new_scheme = (data) =>
    apis
        .createData(`v1/admin/scheme`, data, {
            headers: { 'content-type': 'multipart/form-data' },
        })
        .then((res) => res);
export const new_program = (data) =>
    apis
        .createData(`v1/admin/program`, data, {
            headers: { 'content-type': 'multipart/form-data' },
        })
        .then((res) => res);
export const edit_program = (id, data) =>
    apis
        .createData(`v1/admin/program/${id}`, data, {
            headers: { 'content-type': 'multipart/form-data' },
        })
        .then((res) => res);
export const edit_scheme = (id, data) =>
    apis
        .createData(`v1/admin/scheme/${id}`, data, {
            headers: { 'content-type': 'multipart/form-data' },
        })
        .then((res) => res);
export const list_schemes = () => apis.getDatas(`v1/admin/scheme`).then((res) => res);
export const list_programs = () => apis.getDatas(`v1/admin/program`).then((res) => res);
export const list_Video = () => apis.getDatas(`v1/admin/video`).then((res) => res);
export const list_Admin = (id) => apis.getDatas(`v1/admin/admin-users?role=${id}`).then((res) => res);
export const list_district = () => apis.getDatas(`v1/admin/district`).then((res) => res);
export const new_district = (data) => apis.createData(`v1/admin/district`, data).then((res) => res);
export const update_Video = (id, data) => apis.createData(`v1/admin/video/${id}`, data).then((res) => res);
export const new_Video = (data) => apis.createData(`v1/admin/video`, data).then((res) => res);
export const delete_Video = (id) => apis.deleteData(`v1/admin/video/${id}`).then((res) => res);
export const delete_Admin = (id) => apis.deleteData(`v1/admin/users/${id}`).then((res) => res);
export const list_Tender = () => apis.getDatas(`v1/admin/tender`).then((res) => res);
export const update_Tender = (id, data) => apis.createData(`v1/admin/tender/${id}`, data).then((res) => res);
export const new_Tender = (data) => apis.createData(`v1/admin/tender`, data).then((res) => res);
export const new_AdminUser = (data) => apis.createData(`v1/admin/create-users`, data).then((res) => res);
export const edit_AdminUser = (data, id) => apis.createData(`v1/admin/update-users/${id}`, data).then((res) => res);
export const delete_Tender = (id) => apis.deleteData(`v1/admin/tender/${id}`).then((res) => res);
export const list_Career = () => apis.getDatas(`v1/admin/career`).then((res) => res);
export const list_Publication = () => apis.getDatas(`v1/admin/publications`).then((res) => res);
export const list_Advertisement = () => apis.getDatas(`v1/admin/advertisements`).then((res) => res);
export const update_Career = (id, data) => apis.createData(`v1/admin/career/${id}`, data).then((res) => res);
export const update_publications = (id, data) =>
    apis.createData(`v1/admin/publications/${id}`, data).then((res) => res);
export const update_advertisement = (id, data) =>
    apis.createData(`v1/admin/advertisements/${id}`, data).then((res) => res);
export const new_Career = (data) => apis.createData(`v1/admin/career`, data).then((res) => res);
export const new_Publication = (data) => apis.createData(`v1/admin/publications`, data).then((res) => res);
export const new_Advertisement = (data) => apis.createData(`v1/admin/advertisements`, data).then((res) => res);
export const delete_Career = (id) => apis.deleteData(`v1/admin/career/${id}`).then((res) => res);
export const delete_publications = (id) => apis.deleteData(`v1/admin/publications/${id}`).then((res) => res);
export const delete_advertisement = (id) => apis.deleteData(`v1/admin/advertisements/${id}`).then((res) => res);
export const list_RTI = () => apis.getDatas(`v1/admin/rti`).then((res) => res);
export const update_RTI = (data) => apis.createData(`v1/admin/rti`, data).then((res) => res);
export const list_ActsRules = () => apis.getDatas(`v1/admin/rules`).then((res) => res);
export const update_ActsRules = (id, data) => apis.createData(`v1/admin/rules/${id}`, data).then((res) => res);
export const new_ActsRules = (data) => apis.createData(`v1/admin/rules`, data).then((res) => res);
export const delete_ActsRules = (id) => apis.deleteData(`v1/admin/rules/${id}`).then((res) => res);
export const list_Photos = () => apis.getDatas(`v1/admin/photos`).then((res) => res);
export const new_Photos = (data) => apis.createData(`v1/admin/photos`, data).then((res) => res);
export const update_Photos = (id, data) => apis.createData(`v1/admin/photos/${id}`, data).then((res) => res);
export const delete_Photos = (id) => apis.deleteData(`v1/admin/photos/${id}`).then((res) => res);

export const list_Council = () => apis.getDatas(`v1/admin/member`).then((res) => res);
export const program_report_list = (type) =>
    apis.getDatas(`v1/admin/reports/summary${type ? `?type=${type}` : ''}`)
      .then((res) => res);
  export const list_Testimonials = () => apis.getDatas(`v1/admin/testimonials`).then((res) => res);
export const list_ContactUs = () => apis.getDatas(`v1/admin/contact`).then((res) => res);
export const update_Council = (id, data) => apis.createData(`v1/admin/member/${id}`, data).then((res) => res);
export const update_Testimonials = (id, data) =>
    apis.createData(`v1/admin/testimonials/${id}`, data).then((res) => res);
export const new_Council = (data) => apis.createData(`v1/admin/member`, data).then((res) => res);
export const new_testimonials = (data) => apis.createData(`v1/admin/testimonials`, data).then((res) => res);
export const delete_Council = (id) => apis.deleteData(`v1/admin/member/${id}`).then((res) => res);
export const delete_testimonial = (id) => apis.deleteData(`v1/admin/testimonials/${id}`).then((res) => res);
export const list_News = () => apis.getDatas(`v1/admin/latestnews`).then((res) => res);
export const list_Internship = () => apis.getDatas(`v1/admin/internships`).then((res) => res);
export const update_News = (id, data) => apis.createData(`v1/admin/latestnews/${id}`, data).then((res) => res);
export const update_Internship = (id, data) => apis.updateData(`v1/admin/internships/${id}`, data).then((res) => res);
export const new_News = (data) => apis.createData(`v1/admin/latestnews`, data).then((res) => res);
export const new_Internship = (data) => apis.createData(`v1/admin/internships`, data).then((res) => res);
export const delete_News = (id) => apis.deleteData(`v1/admin/latestnews/${id}`).then((res) => res);
export const delete_Internship = (id) => apis.deleteData(`v1/admin/internships/${id}`).then((res) => res);
export const list_Material = () => apis.getDatas(`v1/admin/material`).then((res) => res);
export const get_users = (data) => apis.getDatas(`v1/admin/users${parseQueryParams(data)}`).then((res) => res);
export const update_Material = (id, data) => apis.createData(`v1/admin/material/${id}`, data).then((res) => res);
export const new_Material = (data) => apis.createData(`v1/admin/material`, data).then((res) => res);
export const delete_Material = (id) => apis.deleteData(`v1/admin/material/${id}`).then((res) => res);
export const create_question = (data) => apis.createData(`v1/questions`, data).then((res) => res);
export const list_About_kied = () => apis.getDatas(`v1/admin/about`).then((res) => res);
export const update_about_kied = (data) => apis.createData(`v1/admin/about`, data).then((res) => res);
export const list_Our_Team = () => apis.getDatas(`v1/admin/our-team`).then((res) => res);
export const new_TeamMember = (data) => apis.createData(`v1/admin/our-team`, data).then((res) => res);
export const update_TeamMember = (id,data) => apis.createData(`v1/admin/our-team/${id}`, data).then((res) => res);
export const delete_TeamMember = (id) => apis.deleteData(`v1/admin/our-team/${id}`).then((res) => res);
export const list_Partners = () => apis.getDatas(`v1/admin/our-partners`).then((res) => res);
export const new_Partners = (data) => apis.createData(`v1/admin/our-partners`, data).then((res) => res);
export const update_Partners = (id, data) => apis.createData(`v1/admin/our-partners/${id}`, data).then((res) => res);
export const delete_Partners = (id) => apis.deleteData(`v1/admin/our-partners/${id}`).then((res) => res);

export const list_Banner = () => apis.getDatas(`v1/admin/banners`).then((res) => res);
export const list_program_feedback = (params = {}) =>
    apis.getDatas(`v1/admin/program-feedbacks`, { params }).then((res) => res);
export const program_reports_detail = (type, id) =>
    apis
      .getDatas(`v1/admin/reports/details?type=${type}&id=${id}`)
      .then((res) => res);
export const incubation_reports_detail = (type, id) =>
    apis
      .getDatas(`v1/admin/reports/details?type=${type}&status=${id}`)
      .then((res) => res);
  export const new_Banner = (data) => apis.createData(`v1/admin/banners`, data).then((res) => res);
export const update_Banner = (id, data) => apis.createData(`v1/admin/banners/${id}`, data).then((res) => res);
export const delete_Banner = (id) => apis.deleteData(`v1/admin/banners/${id}`).then((res) => res);

export const list_Report = () => apis.getDatas(`v1/admin/annual-reports`).then((res) => res);
export const update_Report = (id, data) => apis.createData(`v1/admin/annual-reports/${id}`, data).then((res) => res);
export const new_Report = (data) => apis.createData(`v1/admin/annual-reports`, data).then((res) => res);
export const delete_Report = (id) => apis.deleteData(`v1/admin/annual-reports/${id}`).then((res) => res);
export const schedule_interview = (id, formData) =>
    apis.createData(`v1/admin/incubation-applications/${id}/schedule-interview`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).then((res) => res);

export const upload_cv_admin = (id, formData) =>
    apis.createData(`v1/admin/incubation-applications/${id}/upload-offer-docs`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }).then((res) => res);


export const space_allotment = (id, formData) =>
    apis.patchData(`v1/admin/incubation-applications/${id}/space-allotment`, formData, {
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((res) => res);

    export const confirmation_move = (id, formData) =>
    apis.patchData(`v1/admin/incubation-applications/${id}/mark-move-in`, formData, {
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((res) => res);

    
